module.exports = __webpack_public_path__ + "components/flag/static/square/it-8baaed90300651317c89bf36673769d5.svg";